// extracted by mini-css-extract-plugin
export default {"popoverItem":"DetailsWidget_popoverItem__TPHUp","popoverItemActive":"DetailsWidget_popoverItemActive__Wj+ul DetailsWidget_popoverItem__TPHUp"};